class PasswordVisibilityAccessibility {
    constructor(root = document) {
        this.root = root;
        this.boundButtons = new WeakSet();
        this.labels = {
            show: (window.freeRadioA11y && window.freeRadioA11y.showPassword) || 'Показати пароль',
            hide: (window.freeRadioA11y && window.freeRadioA11y.hidePassword) || 'Сховати пароль',
        };
    }

    init() {
        this.bindButtons(this.root);

        if (!document.body || typeof MutationObserver === 'undefined') {
            return;
        }

        this.domObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        this.bindButtons(node);
                    }
                });
            });
        });

        this.domObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    bindButtons(root) {
        const buttons = [];

        if (root.matches && root.matches('.wp-hide-pw')) {
            buttons.push(root);
        }

        if (root.querySelectorAll) {
            buttons.push(...root.querySelectorAll('.wp-hide-pw'));
        }

        buttons.forEach((button) => this.bindButton(button));
    }

    bindButton(button) {
        if (this.boundButtons.has(button)) {
            return;
        }

        const input = this.getPasswordInput(button);

        if (!input) {
            return;
        }

        this.boundButtons.add(button);
        this.updateLabel(button, input);

        const icon = button.querySelector('.dashicons');
        if (icon) {
            icon.setAttribute('aria-hidden', 'true');
        }

        button.addEventListener('click', () => {
            window.requestAnimationFrame(() => this.updateLabel(button, input));
        });

        if (typeof MutationObserver !== 'undefined') {
            const typeObserver = new MutationObserver(() => this.updateLabel(button, input));
            typeObserver.observe(input, {
                attributes: true,
                attributeFilter: ['type'],
            });
        }
    }

    getPasswordInput(button) {
        const controlledId = button.getAttribute('aria-controls');
        if (controlledId) {
            const controlledInput = document.getElementById(controlledId);
            if (controlledInput) {
                return controlledInput;
            }
        }

        const container = button.closest('.wp-pwd, .password-input, .user-pass-wrap');
        return container ? container.querySelector('input') : null;
    }

    updateLabel(button, input) {
        const passwordIsVisible = input.type === 'text';
        button.setAttribute('aria-label', passwordIsVisible ? this.labels.hide : this.labels.show);
    }
}

export default PasswordVisibilityAccessibility;
